import { CheckmarkCircleIcon, RemoveIcon } from '../icons/icons';
import './inlineEdit.scss';

export interface InlineEditProps {
    inputValue: string;
    inputName: string;
    isVisible: boolean;
    handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleOnSave: (fieldName: string) => void;
    handleOnClose: () => void;

}
const InlineEdit = ({ inputValue, inputName, isVisible, handleOnChange, handleOnSave, handleOnClose }: InlineEditProps) => {

    return (
        <div className={"edit-wrapper flex-nowrap center-vert" + (isVisible ? "" : " hidden")} data-testid="inline-edit">
            <input className="input-edit" type="text" onChange={handleOnChange} value={inputValue} name={inputName} data-testid="input-edit" />
            <a className="save-edit" onClick={() => handleOnSave(inputName)} data-testid={`save-${inputName}-edit`}>
                <CheckmarkCircleIcon />
            </a>
            <a className="remove-button" onClick={handleOnClose} title="Cancel Edit" aria-disabled style={{ paddingBottom: "3px" }}>
                <RemoveIcon width={10} />
            </a>
        </div>
    );
};

export default InlineEdit;